
import React from 'react';
import { RotateCcw } from 'lucide-react';
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';

interface CrawlActionsProps {
  onNewCrawl: () => void;
}

const CrawlActions: React.FC<CrawlActionsProps> = ({
  onNewCrawl
}) => {
  return (
    <div className="flex gap-2" data-testid="crawl-actions">
      <ActionButton 
        icon={<RotateCcw size={20} />} 
        tooltip="Start a new crawl" 
        onClick={onNewCrawl} 
        data-testid="new-crawl-icon-button"
      />
      
      <Button
        onClick={onNewCrawl}
        className="px-4 py-2 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-primary-foreground hover:opacity-90 transition-all"
        data-testid="new-crawl-button"
      >
        New Crawl
      </Button>
    </div>
  );
};

interface ActionButtonProps {
  icon: React.ReactNode;
  tooltip: string;
  onClick: () => void;
  'data-testid'?: string;
}

const ActionButton: React.FC<ActionButtonProps> = ({ 
  icon, 
  tooltip, 
  onClick,
  'data-testid': dataTestId 
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={onClick}
            className="p-2 rounded-md bg-primary/10 text-primary hover:bg-primary/20 transition-colors"
            data-testid={dataTestId}
          >
            {icon}
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CrawlActions;
